//GET and DELETE Ajax
function report_query(url, on_success)
{
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function (){
        if(this.readyState == 4 && this.status == 200)
        {
            if(this.status == 200)
            {
                on_success(this);
            }
            else
            {
                on_success('Error');
            }
        }
    }
    xhttp.open("GET",url,true);
    xhttp.send();
}

function make_new_chart(data,key)
{
    // data = JSON.parse(data);
    if(data.error)
    {
        var errorHTML = '';
        errorHTML = '<div class="graphs" id="graph">';
        errorHTML += '<pre>' + data.error + '</pre>';
        errorHTML += '</div>';
        document.getElementById("graph" + key).outerHTML = errorHTML;
    }
    else{
        if (data.display == "3") {
            google.setOnLoadCallback(createPie(data));
        } else if (data.display == "2") {
            google.setOnLoadCallback(createBar(data));
        } else if (data.display == "1" || data.display == "4") {
            google.setOnLoadCallback(createArea(data));
        } else if (data.display == "2") {
            google.setOnLoadCallback(createBar(data));
        } else if (data.display == "6") {
            google.setOnLoadCallback(createTable(data));
        }
    }
}

function report_graph_drilldown(passedData, gID, key) {
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        type: "POST",
        url: "https://" + window.location.hostname + "/enforcer_reports/" + passedData["clientHash"] +"/"+ passedData["reportHash"] + "/drilldown/" + gID,
        data: { _token: CSRF_TOKEN, key: key, data: JSON.stringify(passedData) },
        restful: true,
        cache: false,
        async: true,
        success: function (data) {
            $(data).insertAfter(".tofill" + key);
            $(".tofill"+key).hide();

        },
        error: function (XMLHttpRequest, textStatus, errorThrown, data) {
        }
    });
}

function reseller_report_graph_drilldown(passedData, gID, key) {
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        type: "POST",
        url: "https://" + window.location.hostname + "/reseller_reports/" + passedData["clientHash"] +"/"+ passedData["reportHash"] + "/drilldown/" + gID,
        data: { _token: CSRF_TOKEN, key: key, data: JSON.stringify(passedData) },
        restful: true,
        cache: false,
        async: true,
        success: function (data) {
            $(data).insertAfter(".tofill" + key);
            $(".tofill"+key).hide();

        },
        error: function (XMLHttpRequest, textStatus, errorThrown, data) {
        }
    });
}

function ajax_data(type, url, callMe) {
    $.ajax({
        type: type,
        //type : "GET",
        url: url,
        dataType: "json",
        restful: true,
        cache: false,
        async: true,
        beforeSend: function (data) {
        },
        success: function (data) {
            callMe.call(this, data);
        },
        error: function (data) {
        }
    });
}

function ajax_post(passedData, gID, key) {
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        type: "POST",
        url: "https://" + window.location.hostname + "/dashboard/" + passedData["clientHash"] +"/"+ passedData["reportHash"] + "/drilldown/" + gID,
        dataType: "html",
        data: {_token: CSRF_TOKEN, key: key, data: passedData},
        // data: data,
        restful: true,
        cache: false,
        async: true,
        success: function (data) {
            $(data).insertAfter(".tofill" + key);
            $(".tofill"+key).hide();

        },
        error: function (XMLHttpRequest, textStatus, errorThrown, data) {

        }
    });

}

function ajax_post_gate(passedData, gID, key) {
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        type: "POST",
        url: "https://" + window.location.hostname + "/enforcer/" + passedData["clientHash"] +"/"+ passedData["reportHash"] + "/drilldown/" + gID,
        dataType: "html",
        data: {_token: CSRF_TOKEN, key: key, data: passedData},
        restful: true,
        cache: false,
        async: true,
        success: function (data) {
            $(data).insertAfter(".tofill" + key);
            $(".tofill"+key).hide();

        },
        error: function (XMLHttpRequest, textStatus, errorThrown, data) {
        }
    });

}

function ajax_post_vpn(passedData, gID, key) {
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        type: "POST",
        url: "https://" + window.location.hostname + "/vpn/" + passedData["clientHash"] +"/"+ passedData["reportHash"] + "/drilldown/" + gID,
        dataType: "html",
        data: {_token: CSRF_TOKEN, key: key, data: passedData},
        // data: data,
        restful: true,
        cache: false,
        async: true,
        success: function (data) {
            $(data).insertAfter(".tofill" + key);
            $(".tofill"+key).hide();

        },
        error: function (XMLHttpRequest, textStatus, errorThrown, data) {

        }
    });

}

function ajax_post_manager(passedData, gID, key) {
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        type: "POST",
        url: "https://" + window.location.hostname + "/vpn/manager/" + passedData["clientHash"] +"/"+ passedData["reportHash"] + "/drilldown/" + gID,
        dataType: "html",
        data: {_token: CSRF_TOKEN, key: key, data: passedData},
        // data: data,
        restful: true,
        cache: false,
        async: true,
        success: function (data) {
            $(data).insertAfter(".tofill" + key);
            $(".tofill"+key).hide();

        },
        error: function (XMLHttpRequest, textStatus, errorThrown, data) {

        }
    });

}

function getLoadingMessage(runNumber)
{
    if(runNumber > 7)
    {
        return 'Please be patient : This is taking longer than expected...';
    }
    var messages = ['Step 1 : Accessing Account Report Data...','Step 2 : Retrieving Data From Archive...','Step 3 : Collating Data to Timeframes...','Step 4 : Populating Plot points...','Step 5 : Aligning Platitudes...','Step 6 : Preparing the Payload...','Step 7 : Polishing Reflective Surfaces...','Step 8 : Articulating Splines...'];
    return messages[runNumber];
}

function makeChart(dataset,key = 0) {
    if (dataset.No_Data || dataset.arrData.error || dataset.arrData.No_Data || dataset.arrData.rows.length == 0 || dataset.arrData.query) {
        var error = "";

        if (dataset.No_Data) {
            error = dataset.No_Data;
        } else if ((dataset.arrData.error) || (dataset.arrData.query)) {
            error = dataset.arrData.error;
        } else if (dataset.arrData.No_Data) {
            error = dataset.arrData.No_Data;
        } else {
            error = "This query brought back no results"
        }
        errorHTML = '<div class="graphs" id="graph">';
        errorHTML += '<pre>' + error + '</pre>';
        errorHTML += '</div>';
        document.getElementById("graph" + dataset.dashseq).outerHTML = errorHTML;


    } else {
        if (dataset.display == "3") {
            google.setOnLoadCallback(createPie(dataset));
        } else if (dataset.display == "2") {
            google.setOnLoadCallback(createBar(dataset));
        } else if (dataset.display == "1" || dataset.display == "4") {
            google.setOnLoadCallback(createArea(dataset));
        } else if (dataset.display == "2") {
            google.setOnLoadCallback(createBar(dataset));
        } else if (dataset.display == "6") {
            google.setOnLoadCallback(createTable(dataset));
        }
    }
}

function createArea(arrData) {
    graphToUse = "graph" + arrData.dashseq;
    var viewType = arrData.view;
    var menu = arrData.menu;
    structData = structureData(arrData.arrData);

    newArr = order2dArr(structData);

    tWidth = document.getElementById(graphToUse).offsetWidth;
    tHeight = document.getElementById(graphToUse).offsetHeight;

    // legend = 1;
    // if (arrData.hasOwnProperty('dashLegend')) {
    //     legend = arrData.dashLegend;
    // }
    tWidth = '60%';
    var data = google.visualization.arrayToDataTable(newArr);
    var options = {
        vAxis: {title: arrData.sumby, minValue: 0, direction: 1},
        hAxis: {titleTextStyle: {color: '#333'}},
        isStacked: true,
        legend: {position: 'right'},
        chartArea: {width: '60%', height: '75%', top: '5%', left: '15%'},
        backgroundColor: 'transparent'
    };

//(arrData.display == "area_chart")
    if (arrData.display == "4") {
        var chart = new google.visualization.LineChart(document.getElementById(graphToUse + "_graph"));
    } else {
        var chart = new google.visualization.AreaChart(document.getElementById(graphToUse + "_graph"));
    }

    varLocation = "https://dashboard.lucidview.net/dashboard.php";
    var curToken = arrData.curToken;
    var realToken = arrData.token + "-" + arrData.curToken;

    chart.draw(data, options);
}
function createTable(arrData) {
    graphToUse = "graph" + arrData.dashseq;

    var structData = structurePie(arrData.arrData);
    varArr = []
    for (var key in arrData.origVars) {
        varArr.push(key);
    }
    for (var key in arrData.vars) {
        if (arrData.vars.hasOwnProperty(key)) {
            $("#" + key).val(arrData.vars[key].toString());
            if (varArr.indexOf(key) > -1) {
                $("#" + key).attr('readonly', 'true');
            }
        }
    }

    var data = new google.visualization.DataTable();
    data.addColumn('string', betterName(arrData.view));
    data.addColumn('number', betterName(arrData.sumby));
    for (var i = 1; i < structData.length; i++) {
        var name = structData[i][0];
        var val = structData[i][1];
        data.addRows([
            [name, {v: val}]
        ]);
    }

    var table = new google.visualization.Table(document.getElementById(graphToUse + '_graph'));

    table.draw(data, {showRowNumber: false, width: '80%', height: '100%'});
}

function structureData(dataArr) {
    rowData = []
    headerArr = []
    for (var col = 0; col < dataArr.header.length; col++) {
        headerArr.push(dataArr.header[col].name);
    }
    rowData.push(headerArr);
    for (var row = 0; row < dataArr.rows.length; row++) {
        tempArr = [];
        for (var col = 0; col < dataArr.header.length; col++) {
            if (col == 0) {
                tempArr.push(timeConverter(dataArr.rows[row]["f"][col]["v"]));
//	    tempArr.push(new Date(dataArr.rows[row]["f"][col]["v"]));
            } else {
//	    if (dataArr.rows[row]["f"].length > row) {
                tempArr.push(parseFloat(dataArr.rows[row]["f"][col]["v"]));
//	    } else {
//	      tempArr.push(parseFloat("0.0"));
//	    }
            }
        }
        rowData.push(tempArr);
    }
    return (rowData);
}

function timeConverter(UNIX_timestamp) {
    var a = new Date(0);
    a.setUTCMilliseconds(UNIX_timestamp);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var weekday = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var dow = weekday[a.getDay()];
    if (min == "0") {
        min = "00"
    }
    var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min;
//  var time = dow + ' ' + hour + ':' + min;
    return time;
}


function order2dArr(arrData) {
    summedArr = {};
    valuesArr = [] //This will be sorted, then compared to summedArr to help us sort the array
    for (var d = 1; d < arrData[0].length; d++) {
        key = d;

        summedArr[key] = 0;
        for (var e = 1; e < arrData.length; e++) {
            summedArr[key] += arrData[e][d];
        }
        valuesArr.push([key, summedArr[key], arrData[0][d]]);
    }
    valuesArr.sort(sortNumber);

    newArr = []
    for (var e = 0; e < arrData.length; e++) {
        tempSort = [];
        tempSort.push(arrData[e][0]);
        for (var f = 0; f < valuesArr.length; f++) {
            tempSort.push(arrData[e][valuesArr[f][0]]);
        }
        newArr.push(tempSort);
    }

    return newArr;
}
function sortNumber(b, a) {
    return b[1] - a[1];
}


function structurePie(arrData) {
    rowData = [["X", "Y"]];
    for (var row = 0; row < arrData.rows.length; row++) {
        tempArr = [];
//	console.log("arrData.rows[row]");
//	console.log(arrData.rows[row]);
        for (var col = 0; col < arrData.header.length; col++) {
//	console.log("arrData.rows[row][f][col][v]");
//	console.log(arrData.rows[row]["f"][col]["v"]);
            if (col == 0) {
                tempArr.push(arrData.rows[row]["f"][col]["v"]);
            } else {
                tempArr.push(parseFloat(arrData.rows[row]["f"][col]["v"]));

            }
        }
        rowData.push(tempArr);
    }
//  console.log("rowData");
    //console.log(rowData);
    return (rowData);

}


function createPie(arrData) {
    graphToUse = "graph" + arrData.dashseq;
    var viewType = arrData.view;
    var menu = arrData.menu;
//	console.log("arrData START")
//	console.log(arrData)
    structData = structurePie(arrData.arrData);
    var allZeros = true;
    for (var i = 0; i < arrData.arrData.count; i++) {
    // if the value in column 1 of row i is not zero, set allZeros to false and break the loop
    if (arrData.arrData.rows[i]['f'][1]['v'] != 0) {
        allZeros = false;
        break;
        }
    }

    if (allZeros)
    {
        var error = 'These Values cannot be represented as a pie chart';
        errorHTML = '<div class="graphs" id="graph">';
        errorHTML += '<pre>' + error + '</pre>';
        errorHTML += '</div>';
        document.getElementById("graph" + arrData.dashseq+"_graph").innerHTML = errorHTML;
        return;
    }

    tWidth = document.getElementById(graphToUse).offsetWidth;
    tHeight = document.getElementById(graphToUse).offsetHeight;
    var data = google.visualization.arrayToDataTable(structData);
    width = tWidth;
    var options = {
        // title:arrData.title.label,
        hAxis: {title: "Lucidview.net", titleTextStyle: {color: '#333'}},
        vAxis: {title: arrData.sumby, minValue: 0, direction: 1},
        hAxis: {titleTextStyle: {color: '#333'}},
//          vAxis: {minValue: 0, direction: 1},
        isStacked: true,
        legend: {position: 'right'},
        chartArea: {width: tWidth, height: '60%', top: '10', left: '10'},
        sliceVisibilityThreshold: 0,
        // width: document.getElementById(graphToUse).offsetWidth,
        // height: document.getElementById(graphToUse).offsetHeight,


//        legend: {position: 'none'},
//         chartArea: {width: '70%', height: '70%'},
    };

    var chart = new google.visualization.PieChart(document.getElementById(graphToUse + "_graph"));
    chart.draw(data, options);

}

function betterName(name) {
    var better_Name = ""
    var parts = name.split("_");
//    console.log(name);
//    console.log(parts);
    for (var i in parts) {
        if (i == 0) {
            better_Name += parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
        } else {
            better_Name += " " + parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
        }
    }
    return better_Name;
}
